import { jsx as e } from "react/jsx-runtime";
import { forwardRef as s } from "react";
import p from "@mui/material/Checkbox";
import c from "styled-components";
import { hexToRgba as k } from "../../theme/utils/styleUtils.js";
import n from "../FormControlLabel/FormControlLabel.js";
const m = {
  root: "checkboxRoot",
  checked: "checkboxChecked",
  disabled: "checkboxDisabled",
  indeterminate: "checkboxIndeterminate",
  colorPrimary: "checkboxColorPrimary",
  colorSecondary: "checkboxColorSecondary"
}, g = c(n).withConfig({
  displayName: "StyledFormControlLabel"
})([
  "&&.formControlLabelRoot{padding:2px;overflow:hidden;}&& .formControlLabelLabel{line-height:22px;}"
]), y = c(p).withConfig({
  displayName: "StyledCheckbox"
})([
  "&&.checkboxRoot{padding:0px;border-radius:0px;height:15px;width:15px;background-color:transparent;}&&.checkboxRoot.checkboxChecked{background-color:",
  ";}&&.checkboxRoot input{width:19px;height:19px;margin:-2px 0px 0px -2px;}&&.checkboxRoot svg{height:22px;width:22px;color:",
  ";}&&.checkboxRoot.Mui-focusVisible svg{box-shadow:0px 0px 4px 0px ",
  ";}&&:hover.checkboxRoot:not(.checkboxDisabled){color:",
  ";}&&:hover.checkboxRoot:not(.checkboxDisabled):not(:active) svg{color:",
  ";}&&.checkboxRoot:active svg{color:",
  ";}&&.checkboxRoot.checkboxDisabled:after{height:15px;width:15px;position:absolute;content:'';border:solid 1px ",
  ";border-radius:2px;}&&.checkboxRoot.checkboxDisabled svg{color:",
  ";}&&.checkboxRoot.checkboxDisabled{background-color:",
  ";}&&.checkboxRoot.checkboxDisabled.checkboxChecked{background-color:",
  ";}"
], ({ theme: o }) => o.colors.white, ({ theme: o }) => o.primaryFill, ({ theme: o }) => k(o.primaryFocus, o.isLightTheme ? 0.5 : 1), ({ theme: o }) => o.isLightTheme ? o.primaryHover : o.text.primary, ({ theme: o }) => o.primaryHover, ({ theme: o }) => o.primarySelected, ({ theme: o }) => o.secondaryDisabled, ({ theme: o }) => o.primaryDisabled, ({ theme: o }) => o.primaryDisabled, ({ theme: o }) => o.secondaryDisabled), f = /* @__PURE__ */ s(({ disabled: o = !1, classes: r = void 0, className: i = void 0, FormControlLabelProps: t = void 0, fullWidth: a = !1, label: d = "", labelPlacement: l = "end", tooltip: b = void 0, ...h }, x) => /* @__PURE__ */ e(g, {
  ...t,
  className: i,
  disabled: o,
  label: d,
  labelPlacement: l,
  tooltip: b,
  control: /* @__PURE__ */ e(y, {
    ...h,
    ref: x,
    classes: {
      ...m,
      ...r
    },
    disabled: o,
    size: "medium",
    color: "default"
  }),
  fullWidth: a
}));
f.displayName = "Checkbox";
export {
  f as default
};
